import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs, pages} from '../constants-enumerate';
import {ApiService, apiRequestInstance} from '../api-service';
import {routerInstance} from '@aofl/router';

/**
 * @summary RoleToggle
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('role-toggle')
class RoleToggle extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of RoleToggle.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is ='role-toggle';

  @property({type: String})
  ['item-class'] = '';

  @property({type: Array, attribute: false})
  roles = [];

  async switchRole(e, role) {
    try {
      apiRequestInstance.purgeCache();
      await ApiService.userValidate(role.id);
    } catch (e) {}

    storeInstance.purge();
    storeInstance.commit({
      namespace: sdoNs.LAYOUT,
      mutationId: 'setShowMenu',
      payload: true
    });

    localStorage.setItem('group_id', role.group_id);
    routerInstance.navigate(pages.HOME, {forceReload: true});
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();

    this.roles = state[sdoNs.SESSION].roles;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default RoleToggle;
